
import { Model } from '@vuex-orm/core';

export default class Channel extends Model {
    static entity = 'channels';

    static fields() {
        return {
            id: this.attr(null),
            name: this.attr(''),
            salespage: this.attr(''),
            permissions: this.attr([]),
            color: this.attr(''),
            slug: this.attr(''),
            homepage: this.attr(false),
            subgroup_id: this.attr(null),
            template: this.attr(''),
            icon: this.attr(''),
            source: this.attr(''),
            image: this.attr(null),
            index: this.attr(0),
        };
    }

    static apiConfig = {
        actions: {
            fetch() {
                const params = new URLSearchParams();

                return new Promise((resolve, reject) => {
                    this.get('/api/v4/community/channels?category=&per_page=9999', {
                        params,
                        dataTransformer: response => response.data.data,
                    }).then((response) => {
                        resolve(response);
                    }).catch((error) => {
                        reject(error.response.data);
                    });
                });
            },

            fetchSubscribedGroups(save = false) {
                const params = new URLSearchParams();

                return new Promise((resolve, reject) => {
                    this.get('/api/v4/channels/subscribed?per_page=9999&include=media', {
                        params,
                        dataTransformer: response => response.data.data,
                        save,
                    }).then((response) => {
                        resolve(response);
                    }).catch((error) => {
                        reject(error.response.data);
                    });
                });
            },
        }
    }
}

window.Channel = Channel;
